module.exports = __webpack_public_path__ + "img/community-bg.9f727ad8.png";